import { _get } from "./Axios";

export default class TeachingMaterialsApi {
    static get() {
        return _get('/masterdata/teaching_materials')
    }
}